import { render, staticRenderFns } from "./TreatmentArchivesModal.vue?vue&type=template&id=1c3d21e6&"
import script from "./TreatmentArchivesModal.vue?vue&type=script&lang=js&"
export * from "./TreatmentArchivesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports